import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LayersControl, TileLayer, useMap } from 'react-leaflet';
import { localStorageEnum } from 'types';
import { MAP_LAYERS } from '../../../slice/map-constants';
import { DynamicMapLayer } from 'react-esri-leaflet';

interface IProps {}

const BaseTileLayers: FC<IProps> = props => {
  const { t } = useTranslation();
  const map = useMap();

  const [isSatellite, setIsSatellite] = useState(false);

  useEffect(() => {
    const mapLayer = localStorage.getItem(localStorageEnum.mapLayer);
    if (mapLayer && mapLayer === MAP_LAYERS.BASE_LAYERS.SATELLITE.url) {
      setIsSatellite(true);
    }
  }, []);

  useEffect(() => {
    if (map) {
      map.on('baselayerchange', function (e: any) {
        if (e?.layer?._url !== MAP_LAYERS.BASE_LAYERS.MAP.url) {
          setIsSatellite(true);
          localStorage.setItem(
            localStorageEnum.mapLayer,
            MAP_LAYERS.BASE_LAYERS.SATELLITE.url,
          );
        } else {
          setIsSatellite(false);
          localStorage.setItem(
            localStorageEnum.mapLayer,
            MAP_LAYERS.BASE_LAYERS.MAP.url,
          );
        }
      });
    }
    return () => {
      map.off('baselayerchange');
    };
  }, [map]);

  return (
    <>
      <LayersControl position="topleft">
        <LayersControl.BaseLayer
          checked={!isSatellite}
          name={t('Map.LayersOptions.Map', 'Map')}
        >
          <TileLayer
            url={MAP_LAYERS.BASE_LAYERS.MAP.url}
            maxZoom={19}
            maxNativeZoom={19}
          />
        </LayersControl.BaseLayer>
        <LayersControl.BaseLayer
          checked={isSatellite}
          name={t('Map.LayersOptions.Satellite', 'Satellite')}
        >
          <DynamicMapLayer url={MAP_LAYERS.BASE_LAYERS.SATELLITE.url} />
        </LayersControl.BaseLayer>
      </LayersControl>
    </>
  );
};

export default BaseTileLayers;
